"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerGuardsT = exports.ServerGuards = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class ServerGuards {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsServerGuards(bb, obj) {
        return (obj || new ServerGuards()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsServerGuards(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new ServerGuards()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    canDoMounting() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    canDoYawReset() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    canDoUserHeightCalibration() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startServerGuards(builder) {
        builder.startObject(3);
    }
    static addCanDoMounting(builder, canDoMounting) {
        builder.addFieldInt8(0, +canDoMounting, +false);
    }
    static addCanDoYawReset(builder, canDoYawReset) {
        builder.addFieldInt8(1, +canDoYawReset, +false);
    }
    static addCanDoUserHeightCalibration(builder, canDoUserHeightCalibration) {
        builder.addFieldInt8(2, +canDoUserHeightCalibration, +false);
    }
    static endServerGuards(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createServerGuards(builder, canDoMounting, canDoYawReset, canDoUserHeightCalibration) {
        ServerGuards.startServerGuards(builder);
        ServerGuards.addCanDoMounting(builder, canDoMounting);
        ServerGuards.addCanDoYawReset(builder, canDoYawReset);
        ServerGuards.addCanDoUserHeightCalibration(builder, canDoUserHeightCalibration);
        return ServerGuards.endServerGuards(builder);
    }
    unpack() {
        return new ServerGuardsT(this.canDoMounting(), this.canDoYawReset(), this.canDoUserHeightCalibration());
    }
    unpackTo(_o) {
        _o.canDoMounting = this.canDoMounting();
        _o.canDoYawReset = this.canDoYawReset();
        _o.canDoUserHeightCalibration = this.canDoUserHeightCalibration();
    }
}
exports.ServerGuards = ServerGuards;
class ServerGuardsT {
    constructor(canDoMounting = false, canDoYawReset = false, canDoUserHeightCalibration = false) {
        this.canDoMounting = canDoMounting;
        this.canDoYawReset = canDoYawReset;
        this.canDoUserHeightCalibration = canDoUserHeightCalibration;
    }
    pack(builder) {
        return ServerGuards.createServerGuards(builder, this.canDoMounting, this.canDoYawReset, this.canDoUserHeightCalibration);
    }
}
exports.ServerGuardsT = ServerGuardsT;
